import { events } from "@/mocks/events";
import SectionHeading from "./SectionHeading";

export default function FocusSection() {
  const [lead, ...rest] = events;
  const side = rest.slice(0, 2);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section id="focus" className="w-full bg-background-50 px-4 md:px-8 py-14 md:py-20">
      <div className="w-full">
        <SectionHeading
          eyebrow="今日焦点盘点"
          title="今天最值得补课的一个瓜"
          desc="从事件起点到最新进展，我们把一个热点拆成「起因、发酵、回应、降温」四个阶段，读一遍就够。"
          action={{ label: "查看全部事件", href: "#events", onClick: () => scrollTo("events") }}
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
          <article className="lg:col-span-2 group relative rounded-lg overflow-hidden border border-background-200">
            <div className="relative w-full h-[260px] md:h-[420px]">
              <img
                src={lead.image}
                alt={`${lead.title} 事件盘点配图`}
                title={`${lead.title} - 5.1吃瓜娱乐盘点`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent" />
              <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                <i className="ri-fire-fill" />
                {lead.tag}
              </span>
              <div className="absolute bottom-0 inset-x-0 p-5 md:p-7">
                <div className="flex items-center gap-3 text-xs text-background-200 mb-3">
                  <span className="px-2 py-0.5 rounded bg-accent-500 text-foreground-950 font-medium">
                    {lead.category}
                  </span>
                  <span>{lead.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {(lead.heat / 100).toFixed(1)}k 热度
                  </span>
                </div>
                <h3 className="font-heading font-bold text-background-50 text-xl md:text-2xl leading-snug mb-3">
                  {lead.title}
                </h3>
                <p className="hidden sm:block text-sm text-background-100/85 leading-relaxed max-w-2xl">
                  {lead.summary}
                </p>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-4 md:gap-6">
            {side.map((item) => (
              <article
                key={item.id}
                className="group flex-1 flex gap-4 rounded-lg border border-background-200 bg-background-100/70 p-4 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="w-24 h-24 md:w-28 md:h-28 shrink-0 rounded-md overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} 事件盘点配图`}
                    title={`${item.title} - 5.1吃瓜娱乐盘点`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex flex-col">
                  <div className="flex items-center gap-2 text-[11px] text-foreground-500 mb-1.5">
                    <span className="text-primary-600 font-medium">{item.category}</span>
                    <span>{item.time}</span>
                  </div>
                  <h3 className="font-heading font-bold text-foreground-950 text-sm md:text-base leading-snug mb-2 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-3">
                    {item.summary}
                  </p>
                </div>
              </article>
            ))}

            <div className="rounded-lg border border-dashed border-primary-300 bg-primary-50 p-4">
              <p className="text-xs md:text-sm text-foreground-700 leading-relaxed">
                <span className="font-medium text-primary-700">编辑按语：</span>
                娱乐事件的信息密度很高，但推进节奏并不均匀。我们更在意「每一步是谁推动了风向」，而不是谁的声音更大。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}